<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.943 2.943v5.434h5.573m-5.422 6.86a9.123 9.123 0 0 0 3.994 4.585 9.492 9.492 0 0 0 6.06 1.135A9.359 9.359 0 0 0 18.6 18.14a8.883 8.883 0 0 0 .79-11.32 9.283 9.283 0 0 0-5.014-3.513 9.51 9.51 0 0 0-6.16.324 9.208 9.208 0 0 0-4.593 4.016" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>
</template>
